import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  icon: '🗂️',
  number: '01',
  title: 'Choose a build',
  description: 'Pick a card based on age, time, and the kind of challenge your child is ready for.'
}, {
  icon: '🧰',
  number: '02',
  title: 'Gather simple supplies',
  description: 'Everything needed is listed upfront, with easy material swaps when needed.'
}, {
  icon: '🚀',
  number: '03',
  title: 'Build, test, and improve',
  description: 'Follow the visual steps, discover why it works, and take on the next challenge.'
}];
export function HowItWorks() {
  return <section className="w-full bg-ivory px-5 py-12 sm:py-20" data-id="element-134" data-mp="cpvlowcoh9nv">
      <div className="mx-auto max-w-5xl" data-id="element-135" data-mp="gsi9mm68aafs">
        <div className="mx-auto max-w-2xl text-center" data-id="element-136" data-mp="gr734eleeokz">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-navy sm:text-4xl" data-id="element-137" data-mp="14ici6rjilcu8">
            How it works
          </h2>
          <p className="mt-3 text-sm text-navy/70 sm:text-base" data-id="element-138" data-mp="19bp7l3w0pno1">
            Simple to start. Exciting to finish.
          </p>
        </div>

        <div className="mt-12 flex flex-col gap-8 md:flex-row md:gap-6" data-id="element-139" data-mp="2mncqd8tiooit">
          {steps.map((step, i) => <React.Fragment key={step.number} data-id="element-140" data-mp="31citv8ze10wi" data-mpi={i}>
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.45,
            delay: i * 0.1
          }} className="flex flex-1 flex-col items-center text-center" data-id="element-141" data-mp="31daejorg5e80">
                <span className="flex h-16 w-16 items-center justify-center rounded-full border border-blue/20 bg-white text-3xl" data-id="element-142" data-mp="3kalhpkg78rsq">
                  {step.icon}
                </span>
                <span className="mt-4 font-serif-display text-2xl font-bold text-blue" data-id="element-143" data-mp="1pw2grmbb2wct">
                  {step.number}
                </span>
                <h3 className="mt-2 text-lg font-bold text-navy" data-id="element-144" data-mp="1kysev76qcs83">{step.title}</h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-navy/70" data-id="element-145" data-mp="3l0iimbddnusu">
                  {step.description}
                </p>
              </motion.div>
              {i < steps.length - 1 && <div className="mx-auto h-8 w-px bg-blue/25 md:hidden" aria-hidden="true" data-id="element-146" data-mp="3tzdrxwbpxl0d" />}
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}